export default "__VITE_ASSET__BF8SGcGU__"